var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.className,attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5.5 15L14.5 10L5.5 5","fill":"#202830"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }